module.exports = __webpack_public_path__ + "static/media/2_pl.6ef90313.png";